export enum MessageStatusType {
    SENT = "sent",
    RECEIVED = "received",
    READ = "read",
    PENDING = "pending",
    DELIVERED = "delivered",
    DECLINED = "declined",
    DELETED = "deleted",
    NONE = "none",
}
